import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import Popup from "./Popup";

const DocLink = (props) => {

    const navigate = useNavigate();
    const [open, setOpen] = useState(true);
    const [done, setDone] = useState(false);
    const component=props.component;

    useEffect(() => {
        if (done) {
            setOpen(false);
            navigate(-1);
        }
    }, [done])

    return (
        <>
            <Popup open={open} setDone={setDone} component={component} />
        </>
    );
}

export default DocLink;
